import {
    putRoutePaymentLoading,
    putRoutePaymentRequest,
    putRoutePaymentSuccess,
    putRoutePaymentReject,
    putRoutePaymentReset
} from "../../actions/route/putPayment";

export const putRoutePayment = (formData) => async (dispatch, getState) => {
    dispatch(putRoutePaymentLoading());
    try {
        const { data } = await putRoutePaymentRequest(formData, getState);
        dispatch(putRoutePaymentSuccess(data))
    } catch (error) {
        dispatch(putRoutePaymentReject(error))
    } finally {
        setTimeout(() => { dispatch(putRoutePaymentReset()) }, 3000);
    }
    return Promise.resolve();
};